import { QueryResolvers } from '@spazious/dollhouse-graphql';
import { migrateGraph } from '@spazious/dollhouse-shallow-graph';
import { VirtualMeetingRoomSetupTemplateRead } from '@spazious/react-booking-engine';

import { ApolloContext } from '../context.js';

/**
 * Resolver for the templates query.
 */
export const templates: QueryResolvers<ApolloContext>['templates'] = async (
  _,
  variables,
  context
) => {
  const { api } = context;
  const { spaceId } = variables;

  const result = await api.diagramming.listDiagrammingVirtualMeetingRoomSetupTemplates({
    sort: variables.sort ?? undefined,
    filterVirtualMeetingRoom: spaceId,
    filterSearch: variables.filters?.search ?? undefined,
  });

  const templates: VirtualMeetingRoomSetupTemplateRead[] = result.data.data;

  return templates.map((template) => ({
    id: template.attributes!.uuid!.toString(),
    name: template.attributes!.name,
    graph: migrateGraph(template.attributes!.graph ? JSON.parse(template.attributes!.graph) : null),
    description: '',
  }));
};
